module.exports = __webpack_public_path__ + "static/media/popup-bg.0902ad46.mp4";